import React from "react";
import PropTypes from "prop-types";
import { Cell } from "fixed-data-table-2";

// Render basic text data
export const TextCell = ({ rowIndex, field, data, ...props }) => (
  <Cell {...props}>{data[rowIndex][field] || "-"}</Cell>
);

TextCell.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired
};

// Render links as clickable
export const LinkCell = ({ rowIndex, field, data, ...props }) => (
  <Cell {...props}>
    <a href={data[rowIndex][field]}>{data[rowIndex][field]}</a>
  </Cell>
);

LinkCell.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired
};
